var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"themeToggle w-12 h-12 bg-transparent border-transparent rounded",class:{
    '--isDark': _vm.themeDark
  },attrs:{"title":"Toggle Theme","aria-label":"Toggle Theme"},on:{"click":_vm.toggle}},[_c('svg-theme')],1)}
var staticRenderFns = []

export { render, staticRenderFns }